import { ApiRequest } from "src/models/api.request";
import HbsVezneTanimDTO from "src/models/Vezne/HbsVezneTanimDTO";
import { ApiService } from "src/services/core";
import { helper } from "src/utils/helper";

class HbsVezneTanimDTOService {
    public service: ApiService<HbsVezneTanimDTO>;
    constructor() {
        this.service = new ApiService<HbsVezneTanimDTO>("HbsVezneTanimDTO");
    };
    createUpdate = (data: HbsVezneTanimDTO) => {
        if (data.id > 0) {
            return this.service.update({
                ...data,
                adi: helper.UpperCaseAsc(data.adi)
            });
        } else {
            return this.service.create({
                ...data,
                adi: helper.UpperCaseAsc(data.adi)
            });
        }
    };
    getByAllData = () => {
        return this.service.find({});
    };
    getByPosId = (id: number) => {
        return this.service.getOne(id);
    };
    deleteRecord = (id: number) => {
        return this.service.delete(id);
    };
    getDetayliArama = (aramaModel: HbsVezneTanimDTO) => {
        let req: ApiRequest<HbsVezneTanimDTO> = {
            sorts: [
                { fieldName: "id", ascending: false },
            ],
            filters: {
                groupOperator: 'and',
                predicates: []
            }
        }
        if (aramaModel.multiOrganizasyon?.length > 0) {
            let orgArr = aramaModel.multiOrganizasyon.split(",");
            req.filters.predicates.push({
                fieldName: "organizasyonId",
                operator: "in",
                not: false,
                value1: orgArr
            })
        }
        if (aramaModel.adi)
            req.filters.predicates.push({
                fieldName: "adi",
                operator: "like",
                value1: helper.upperCase(aramaModel.adi)
            })
        if (aramaModel.fkVeznePoscihaztanim > 0)
            req.filters.predicates.push({
                fieldName: 'fkVeznePoscihaztanim',
                operator: '=',
                value1: aramaModel.fkVeznePoscihaztanim
            })
        return this.service.find(req)
    };
}

export default new HbsVezneTanimDTOService();